import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../../../services/api";
import Calendar from '../../../media/calendar.png';
import Trophy from '../../../media/trophy.png';
import Certificate from '../../../media/certificate2.png';
import Course from '../../../media/my_courses.png';
import User from '../../../media/person.png';
import Back from '../../../media/back.png';
import Courses from '../../../media/my_courses.png';
import Results from '../../../media/my_results.png';
import "../css/account_panel.css";
import { confirmToast } from "./confirmToast";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import unlock from '../../../media/eye1.png';
import lock from '../../../media/eye2.png';
import Coupon from '../../../media/coupon.png';
import Account from '../../../media/account_settings.png';
import Complete from '../../../media/complete.png';
import Not_complete from '../../../media/not_complete.png';
import Export from '../../../media/export_data.png';
import Export2 from '../../../media/export_pdf.png';
import Save from '../../../media/save.png';
import Delete from '../../../media/delete.png';
import Search from '../../../media/search2.png';
import ActiveIcon from "../../../media/active.png";
import InactiveIcon from "../../../media/inactive.png";
import UserCourseProgressDetail from "../../pages/components/admin_dashboard/user_detail";
import Select from "react-select";


export default function AccountPanel({ onClose }) {
  const [selected, setSelected] = useState("");
  const [courses, setCourses] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userCertificates, setUserCertificates] = useState([]);
  const [userProgress, setUserProgress] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [userData, setUserData] = useState({
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        nation: '',
        city: '',
        is_org_admin: false,
        tax_id: '',
      });
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false); 
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const [orgCode, setOrgCode] = useState("");
  const [joinLoading, setJoinLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const [courseDetailView, setCourseDetailView] = useState(null);
  const [loadingCourseDetail, setLoadingCourseDetail] = useState(false);

  const [selectedCourseFilter, setSelectedCourseFilter] = useState("");

  const [openExamId, setOpenExamId] = useState(null);

  const [selectedExportUsers, setSelectedExportUsers] = useState([]);

  const [search, setSearch] = useState("");

  const [selectedStatusFilter, setSelectedStatusFilter] = useState("all");

  const [errors, setErrors] = useState({});

  




  useEffect(() => {
    if (!courseDetailView) return;

    const fetch = async () => {
      try {
        setLoadingCourseDetail(true);

        const res = await ApiService.getUserCourseProgressDetail(
          courseDetailView.userSlug,
          courseDetailView.courseSlug
        );

        setCourseDetailView(prev => ({
          ...prev,
          data: res
        }));
      } catch (err) {
        console.error(err);
        toast.error("Errore nel caricamento dettagli corso");
      } finally {
        setLoadingCourseDetail(false);
      }
    };

    fetch();
  }, [courseDetailView?.courseSlug]);

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await ApiService.getMyData();
        setUserData(data);
        setSelected(data.is_org_admin ? "Corsi abilitati" : "I miei corsi");
        setInitialized(true);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  
  useEffect(() => {
    if (!initialized) return;

    if (userData.is_org_admin) {
      if (selected === "Corsi abilitati") loadOrgCourses();
      if (selected === "I miei utenti") loadUsers();
      if (selected === "Esporta dati utenti") loadUsers();
    } else if (!userData.is_org_admin) {
      if (selected === "I miei corsi") loadCourses();
      if (selected === "I miei certificati") loadCertificates();
    }
  }, [selected, userData, initialized]);

  useEffect(() => {
    if (!initialized) return;

    if (userData.is_org_admin) {
      loadOrgCourses();
    }
  }, [initialized, userData.is_org_admin]);

  useEffect(() => {
    setSelectedUser(null);
    setUserCertificates([]);
    setUserProgress([]);
    setCourseDetailView(null);
    setSelectedCourseFilter("");
    setSelectedExportUsers([]);
    setSearch("");
    setSelectedStatusFilter("all");
  }, [selected]);



  const loadOrgCourses = async () => {
    try {
      const data = await ApiService.getMyOrgCourses(); 
      setCourses(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
        const fetchCountries = async () => {
          try {
            const res = await ApiService.getCountries();
            setCountries(res);
          } catch (err) {
            console.error('Errore:', err);
          } finally {
            setLoading(false);
          }
        };
    
        fetchCountries();
      }, []);

 
  const loadCourses = async () => {
    try {
      const data = await ApiService.getMyCourses();
      setCourses(data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadUsers = async (courseSlug = null) => {
    try {
      const data = await ApiService.getMyUsers(courseSlug);
      setUsers(data);
    } catch (err) {
      console.error(err);
    }
  }

  const goToCourse = (slug) => {
    navigate(`/course/${slug}`);
    onClose();
  };

 

  const loadCertificates = async () => {
    try {
      const res = await ApiService.getCertificates();

      const certs = (res || []).map((c) => ({
        id: c.id,
        title: c.course_title,
        file: c.file,
      }));

      setCertificates(certs);
    } catch (err) {
      console.error("Errore nel caricamento certificati:", err);
      setCertificates([]);
    }
  };

  const handleUserClick = async (user) => {
    setSelectedUser(user);

    setCourseDetailView(null);

    setUserLoading(true);

    try {
      const [certs, progress] = await Promise.all([
        ApiService.getUserCertificates(user.slug),
        ApiService.getUserProgress(user.slug)
      ]);

      setUserCertificates(certs);
      setUserProgress(progress);
    } catch (err) {
      console.error(err);
      toast.error("Errore nel caricamento dati utente");
    } finally {
      setUserLoading(false);
    }
  };

  const resetUserView = () => {
    setSelectedUser(null);
    setUserCertificates([]);
    setUserProgress([]);
  };


  
 const handleUpdate = async () => {

  setErrors({});


  

  setLoading(true);

  try {
    const { password, confirmPassword, ...rest } = userData;

    const passwordChanged = !!password?.trim();

    const payload = {
      ...rest,
      ...(password || confirmPassword
        ? {
            password,
            confirmPassword
          }
        : {})
    };



    const updated = await ApiService.updateMyData(payload);

    setUserData({
      ...updated,
      password: "",
      confirmPassword: "",
    });


    toast.success("Dati aggiornati con successo");

  
    if (passwordChanged) {

      

      localStorage.removeItem("token");
      localStorage.removeItem("refresh");

      setTimeout(() => {
        navigate("/login");
        window.location.reload();
      }, 150);
    }

  } catch (err) {
    console.error(err);

    if (err.response && err.response.data) {
      setErrors(err.response.data);
    } else {
      toast.error("Errore durante l'aggiornamento dei dati");
    }
  } finally {
    setLoading(false);
  }
};

  const getErrorMessage = field => {
      if (!errors[field]) return null;
      return Array.isArray(errors[field]) ? errors[field][0] : errors[field];
    };

  const handleDelete = async () => {
     confirmToast({
            message: "Sei sicuro di voler eliminare il tuo account?",
            type: "error",
            confirmText: "Elimina",
             onConfirm: async () => {
              try {
                await ApiService.deleteMyAccount();
                toast.success("Account eliminato con successo");
                navigate(`/`);
                window.location.reload();
              } catch (err) {
                toast.error("Errore durante la cancellazione dell'account");
                      
              }
            },
          });
  };


  const handleJoinOrganization = async () => {
    if (!orgCode) return;

    setJoinLoading(true);

    try {
      await ApiService.joinOrganization({
        code: orgCode,
      });

      toast.success("Codice registrato con successo");

      setOrgCode("");
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.error || "Errore durante il join");
    } finally {
      setJoinLoading(false);
    }
  };

  const mergedCourseMap = new Map();

  
  courses.forEach(c => {
    mergedCourseMap.set(c.slug, {
      slug: c.slug,
      title: c.title,
      isOrg: true
    });
  });

 
  users.forEach(u => {
    (u.courses || []).forEach(c => {
      if (!mergedCourseMap.has(c.slug)) {
        mergedCourseMap.set(c.slug, {
          slug: c.slug,
          title: c.title,
          isOrg: false
        });
      }
    });
  });


  const courseOptions = [
  { value: "", label: "Tutti i corsi" },

  ...Array.from(mergedCourseMap.values()).map(c => ({
    value: c.slug,
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={c.isOrg ? ActiveIcon : InactiveIcon}
          alt=""
          style={{ width: 20, height: 20 }}
        />
        {c.title}
      </span>
    )
  }))
];

const statusOptions = [
    { value: "all", label: "Tutti gli utenti" },
    { value: "active", label: "Utenti attivi" },
    { value: "inactive", label: "Utenti non attivi" },
  ];

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "48px",
      borderRadius: "14px",
      backgroundColor: "#fff",
      border: state.isFocused
        ? "1px solid #cecdcd"
        : "1px solid #e5e7eb",
      boxShadow: state.isFocused
        ? "0 0 0 4px rgba(206,205,205,0.25)"
        : "none",
      transition: "all 0.2s ease",

      "&:hover": {
        borderColor: "#cecdcd"
      }
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 14px"
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#cecdcd",
      fontWeight: 400
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#393939",
      fontWeight: 500
    }),

    menu: (provided) => ({
      ...provided,
      marginTop: "8px",
      borderRadius: "14px",
      overflow: "hidden",
      border: "1px solid #e5e7eb",
      boxShadow: "0 12px 30px rgba(0,0,0,0.08)"
    }),

    menuList: (provided) => ({
      ...provided,
      padding: "6px"
    }),

    option: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      marginBottom: "2px",
      padding: "12px 14px",
      cursor: "pointer",
      transition: "all 0.15s ease",

      backgroundColor: state.isSelected
        ? "#cecdcd"
        : state.isFocused
        ? "#f5f5f5"
        : "#fff",

      color: "#393939",
      fontWeight: state.isSelected ? 600 : 500
    }),

    indicatorSeparator: () => ({
      display: "none"
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused
        ? "#393939"
        : "#cecdcd",

      "&:hover": {
        color: "#393939"
      }
    }),

    clearIndicator: (provided) => ({
      ...provided,
      color: "#cecdcd",

      "&:hover": {
        color: "#393939"
      }
    })
  };


  const handleExport = async () => {
    if (selectedExportUsers.length === 0) return;

    try {
      const pdfBlob = await ApiService.exportUsersPdf({
        users: selectedExportUsers,
      });

      const url = window.URL.createObjectURL(new Blob([pdfBlob]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "export_utenti.pdf");

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error(err);
      toast.error("Errore durante export PDF");
    }
  };

  const toggleUserSelection = (slug) => {
    setSelectedExportUsers(prev =>
      prev.includes(slug)
        ? prev.filter(s => s !== slug)
        : [...prev, slug]
    );
  };

  const normalizedSearch = search.trim().toLowerCase();

  const filteredUsers = users.filter((u) => {
    const fullName = `${u.first_name} ${u.last_name}`.toLowerCase();

    if (!fullName.includes(normalizedSearch)) {
      return false;
    }

    if (!selectedCourseFilter || selectedStatusFilter === "all") {
      return true;
    }

    const selectedCourse = (u.courses || []).find(
      c => c.slug === selectedCourseFilter
    );

    if (!selectedCourse) {
      return false;
    }

    if (selectedStatusFilter === "active") {
      return selectedCourse.is_active;
    }

    if (selectedStatusFilter === "inactive") {
      return !selectedCourse.is_active;
    }

    return true;
  });

  const exportFilteredUsers = filteredUsers.filter(u => {
    const course = (u.courses || []).find(
      c => c.slug === selectedCourseFilter
    );

    if (!selectedCourseFilter) return true;

    if (!course) return false;

    if (selectedStatusFilter === "active") {
      return course.is_active === true;
    }

    if (selectedStatusFilter === "inactive") {
      return course.is_active === false;
    }

    return true;
  });

const filteredCourses = courses.filter(c => {
  const title = `${c.title}`.toLowerCase();

  return (
    title.includes(normalizedSearch) 
  );
});

  
  const menuItems = !initialized
  ? []
  : userData.is_org_admin
    ? [
        { label: "Corsi abilitati", icon: Course },
        { label: "I miei utenti", icon: User },
        { label: "Aggiungi coupon", icon: Coupon },
        { label: "Esporta dati utenti", icon: Export },
        { label: "Impostazioni account", icon: Account },
      ]
    : [
        { label: "I miei corsi", icon: Course },
        { label: "I miei certificati", icon: Certificate },
        { label: "Aggiungi coupon", icon: Coupon },
        { label: "Impostazioni account", icon: Account },
      ];

 
  
  
  if (!initialized) return null;

  return (
    <div className="account-overlay">
      <div className="account-panel">
        <button className="close-btn" onClick={onClose}>✖</button>
        <div className="account-layout">
         <div className="account-menu">
            {menuItems.map(tab => (
              <div
                key={tab.label}
                className={selected === tab.label ? "menu-item active" : "menu-item"}
                onClick={() => setSelected(tab.label)}
              >
                <img src={tab.icon} alt="" style={{width:'24px', marginRight: '10px'}} />

                <span>{tab.label}</span>
              </div>
            ))}
          </div>

          <div className="account-content">
            
            {userData.is_org_admin && selected === "Corsi abilitati" && (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                    gap: "16px",
                    flexWrap: "wrap"
                  }}
                >
                  <h2><img src={Course} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>Corsi abilitati</h2>
                  <div>
                    <img src={Search} alt="" style={{ width: 36, marginRight: 10, marginTop: "-5px" }}/>
                    <input
                    type="text"
                    placeholder="Cerca corso..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      padding: "11.5px",
                      borderRadius: "14px",
                      border: "1px solid #e5e7eb",
                      minWidth: "250px",
                      backgroundColor:"#fff",
                      marginTop: "-10px"
                    }}
                  />
                  </div>
                </div>

                {filteredCourses.map(c => (
                  <div
                    key={c.id}
                    className="course-item"
                    style={{
                      marginBottom: "10px",
                      padding: "15px"
                    }}
                  >
                    <div
                      className="course-item-left"
                      style={{
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <img
                        src={c.main_img}
                        alt={c.title}
                        style={{
                          width: 60,
                          height: 60,
                          marginRight: 15,
                          objectFit: "cover",
                          borderRadius: "36px",
                          flexShrink: 0
                        }}
                      />

                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            fontWeight: "600",
                            marginBottom: "8px",
                            wordBreak: "break-word"
                          }}
                        >
                          {c.title}
                        </div>

                        <div
                          style={{
                            fontSize: "14px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px"
                          }}
                        >
                          <span>
                            Codice: <strong>{c.code}</strong>
                          </span>

                          {c.expires_at ? (
                            <span>
                            Accesso disponibile fino al:{" "}
                            <strong>
                              {new Date(c.expires_at).toLocaleDateString("it-IT")}
                            </strong>
                          </span>
                          ) : (
                            <span>
                            Accesso illimitato
                            </span>
                          )}


                          <span>
                            Posti disponibili:{" "}
                            <strong>
                              {c.available_seats}
                            </strong>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {userData.is_org_admin && selected === "I miei utenti" && (
              <div>

                {!selectedUser && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "20px",
                        gap: "16px",
                        flexWrap: "wrap"
                      }}
                    >
                      <h2>
                        <img src={User} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>
                        I miei utenti
                      </h2>
                      <div>
                        <img src={Search} alt="" style={{ width: 36, marginRight: 10, marginTop: "-5px" }}/>
                        <input
                        type="text"
                        placeholder="Cerca utente..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{
                          padding: "11.5px",
                          borderRadius: "14px",
                          border: "1px solid #e5e7eb",
                          minWidth: "250px",
                          backgroundColor:"#fff",
                          marginTop: "-10px"
                        }}
                      />
                      </div>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                      <Select
                        options={courseOptions}
                        value={
                          courseOptions.find(
                            option => option.value === selectedCourseFilter
                          ) || courseOptions[0]
                        }
                        onChange={async (selectedOption) => {
                          const value = selectedOption?.value || "";

                          setSelectedCourseFilter(value);

                          if (value === "") {
                            setSelectedStatusFilter("all");
                          }

                          await loadUsers(value || null);
                        }}
                        styles={customSelectStyles}
                        theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary: "#cecdcd",
                          primary25: "#f5f5f5",
                          primary50: "#cecdcd"
                        }
                      })}
                      />
                    </div>
                    {selectedCourseFilter !== "" && (
                      <div style={{ marginBottom: "20px" }}>
                        <Select
                          options={statusOptions}
                          value={
                            statusOptions.find(
                              option => option.value === selectedStatusFilter
                            )
                          }
                          onChange={(selectedOption) =>
                            setSelectedStatusFilter(selectedOption.value)
                          }
                          styles={customSelectStyles}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: "#cecdcd",
                              primary25: "#f5f5f5",
                              primary50: "#cecdcd"
                            }
                          })}
                        />
                      </div>
                    )}
                  </>
                )}

              
                {!selectedUser && filteredUsers.map(u => (
                  <div
                    key={u.id}
                    className="course-item"
                    onClick={() => handleUserClick(u)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      marginBottom: "10px"
                    }}
                  >
                    <div className="course-item-left">
                      <img
                        src={User}
                        alt=""
                        style={{
                          width: 60,
                          height: 60,
                          marginRight: 10,
                          objectFit: "cover",
                          borderRadius: "36px"
                        }}
                      />
                      <span  title={`${u.first_name} ${u.last_name}`}>{u.first_name} {u.last_name}</span>
                    </div>
                     <div style={{ display: "flex", alignItems: "center" }}>
                      {(() => {
                        const course = (u.courses || []).find(
                          c => c.slug === selectedCourseFilter
                        );

                        if (!course) return null;

                        return (
                          <img
                            src={course.is_active ? ActiveIcon : InactiveIcon}
                            alt=""
                            style={{ width: 20, height: 20 }}
                          />
                        );
                      })()}
                    </div>
                  </div>
                ))}

                
                {selectedUser && (
                  <div>
                    <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>
                      <h2 style={{ marginBottom: "20px"}}>
                        <img src={User} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>
                        <span
                          title={`${selectedUser.first_name} ${selectedUser.last_name}`}
                          style={{
                            maxWidth: "35vw",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                            verticalAlign: "middle"
                          }}
                        >
                        {selectedUser.first_name} {selectedUser.last_name}
                        </span>
                      </h2>
                      <button 
                      onClick={resetUserView} 
                      className="menu-item" 
                      style={{marginTop:'-5px', marginBottom:'20px', color: "#393939", fontWeight: "500" }}
                    >
                      <img src={Back} alt="" style={{ width: 20, marginRight: 5, marginTop: "-5px" }}/>
                      Torna agli utenti
                    </button>
                    </div>


                    {userLoading && <p>Caricamento...</p>}

                    {!userLoading && (
                      <>
                        <div style={{border: '2px solid #cecdcd', borderRadius: '24px', display:'inline-block', padding: '1rem', marginBottom: '1rem'}}>
                          <img
                            src={Calendar}
                            alt=""
                            style={{ width: 30, marginRight: 10, marginTop: '-5px' }}
                          />
                          Data registrazione: <strong>{new Date(selectedUser.date_joined).toLocaleDateString('it-IT')}</strong>
                        </div>
                        <h4>Certificati</h4>
                        {userCertificates.length === 0 && <p>Nessun certificato</p>}
                        {userCertificates.map(cert => (
                          <div
                            key={cert.course_id}
                            className="course-item"
                            style={{
                              cursor: "pointer",
                              marginBottom: "10px",
                              display: "flex",
                              alignItems: "center",
                              padding: "20px"
                            }}
                            onClick={() => window.open(cert.file, "_blank")}
                          >
                            <div className="course-item-left">
                              <img
                                src={Certificate}
                                alt=""
                                style={{ width: 30, marginRight: 10 }}
                              />
                              <span>Visualizza certificato del corso {cert.course_title}</span>
                            </div>
                          </div>
                        ))}

                        
                        <h4 style={{ marginTop: "20px" }}>Progressi corsi</h4>

                        
                        {!courseDetailView?.data && userProgress.map(p => (
                          <div
                            key={p.id}
                            className="course-item"
                            onClick={() => setCourseDetailView({ userSlug: selectedUser.slug, courseSlug: p.slug, data: null })}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "10px",
                              padding: "20px",
                              cursor: "pointer"
                            }}
                          >
                            <div className="course-item-left">
                              <img
                                src={Course}
                                alt=""
                                style={{ width: 30, marginRight: 10 }}
                              />
                              <span>{p.title}</span>
                            </div>
                            <span>
                              <img src={Trophy} alt="" className="profile-progress" />
                              {p.total_progress}%
                            </span>
                          </div>
                        ))}
                        {courseDetailView?.data && (
                          <UserCourseProgressDetail
                            data={courseDetailView.data}
                            openExamId={openExamId}
                            setOpenExamId={setOpenExamId}
                            onBack={() => {
                              setCourseDetailView(null);
                              setOpenExamId(null);
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            )}

            {userData.is_org_admin && selected === "Aggiungi coupon" && (
              <div>
                <h2 style={{marginBottom:'20px'}}><img src={Coupon} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>Aggiungi coupon</h2>

                <input
                  type="text"
                  placeholder="Inserisci codice coupon"
                  value={orgCode}
                  onChange={(e) => setOrgCode(e.target.value)}
                  style={{
                    padding: "10px",
                    width: "300px",
                    marginBottom: "10px"
                  }}
                />

                <br />

                <button
                  onClick={handleJoinOrganization}
                  disabled={joinLoading}
                  className="btn-update"
                >
                  {joinLoading ? "Convalida..." : "Conferma"}
                </button>
              </div>
            )}

            {userData.is_org_admin && selected === "Esporta dati utenti" && (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                    gap: "16px",
                    flexWrap: "wrap"
                  }}
                >
                  <h2>
                    <img src={Export} alt="" style={{ width: 48, marginRight: 20 }} />
                    Esporta dati utenti
                  </h2>
                  <div>
                    <img src={Search} alt="" style={{ width: 36, marginRight: 10, marginTop: "-5px" }}/>
                    <input
                    type="text"
                    placeholder="Cerca utente..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      padding: "11.5px",
                      borderRadius: "14px",
                      border: "1px solid #e5e7eb",
                      minWidth: "250px",
                      backgroundColor:"#fff",
                      marginTop: "-10px"
                    }}
                  />
                  </div>
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <Select
                    options={courseOptions}
                    value={
                      courseOptions.find(
                        option => option.value === selectedCourseFilter
                      ) || courseOptions[0]
                    }
                    onChange={async (selectedOption) => {
                      const value = selectedOption?.value || "";

                      setSelectedCourseFilter(value);

                      if (value === "") {
                        setSelectedStatusFilter("all");
                      }

                      await loadUsers(value || null);
                    }}
                    styles={customSelectStyles}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: "#cecdcd",
                        primary25: "#f5f5f5",
                        primary50: "#cecdcd"
                      }
                    })}
                  />
                </div>
                {selectedCourseFilter !== "" && (
                  <div style={{ marginBottom: "20px" }}>
                    <Select
                      options={statusOptions}
                      value={
                        statusOptions.find(
                          option => option.value === selectedStatusFilter
                        ) || statusOptions[0]
                      }
                      onChange={(selectedOption) =>
                        setSelectedStatusFilter(selectedOption.value)
                      }
                      styles={customSelectStyles}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary: "#cecdcd",
                          primary25: "#f5f5f5",
                          primary50: "#cecdcd"
                        }
                      })}
                    />
                  </div>
                )}

                    {exportFilteredUsers.map(u => (
                      <div
                          key={u.id}
                          className="course-item"
                          onClick={() => toggleUserSelection(u.slug)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            marginBottom: "10px",
                            padding: "1rem",
                            borderRadius: "24px",
                            transition: "0.2s",
                            backgroundColor: selectedExportUsers.includes(u.slug)
                              ? "#d4edda"
                              : "#cecdcd",
                            border: selectedExportUsers.includes(u.slug)
                              ? "1px solid #28a745"
                              : "2px solid #cececd"
                          }}
                        >


                        <div className="course-item-left">
                          <img
                            src={User}
                            alt=""
                            style={{
                              width: 60,
                              height: 60,
                              marginRight: 10,
                              objectFit: "cover",
                              borderRadius: "36px"
                            }}
                          />
                          <span title={`${u.first_name} ${u.last_name}`}>{u.first_name} {u.last_name}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {(() => {
                            const course = (u.courses || []).find(
                              c => c.slug === selectedCourseFilter
                            );

                            if (!course) return null;

                            return (
                              <img
                                src={course.is_active ? ActiveIcon : InactiveIcon}
                                alt=""
                                style={{ width: 20, height: 20 }}
                              />
                            );
                          })()}
                        </div>
                      </div>
                    ))}

                        <button
                          className="pdf-button"
                          disabled={selectedExportUsers.length === 0}
                          onClick={handleExport}
                          style={{marginTop: '10px'}}
                        >
                          <img src={Export2} alt="" style={{ width: 24, marginRight: 10, marginTop: "-5px" }}/>
                          Esporta PDF
                        </button>
                    </div>
                  )}


            {userData.is_org_admin && selected === "Impostazioni account" && (
                <div>
                <h2 style={{marginBottom:'20px'}}><img src={Account} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>Impostazioni account</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label>Nome</label>
                      <input
                        type="text"
                        value={userData.first_name}
                        onChange={(e) => setUserData({ ...userData, first_name: e.target.value })}
                      />
                    {getErrorMessage('first_name') && (
                        <p className="error">{getErrorMessage('first_name')}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Cognome</label>
                      <input
                        type="text"
                        value={userData.last_name}
                        onChange={(e) => setUserData({ ...userData, last_name: e.target.value })}
                      />
                    {getErrorMessage('last_name') && (
                        <p className="error">{getErrorMessage('last_name')}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Username</label>
                      <input
                        type="text"
                        value={userData.username}
                        onChange={(e) => setUserData({ ...userData, username: e.target.value })}
                      />
                      {getErrorMessage('username') && (
                        <p className="error">{getErrorMessage('username')}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        value={userData.email}
                        onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                      />
                      {getErrorMessage('email') && (
                        <p className="error">{getErrorMessage('email')}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Nazione</label>
                      <Select
                        options={countries}
                        value={
                          countries.find(
                            c => c.value === userData.nation
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setUserData({
                            ...userData,
                            nation: selectedOption?.value || ""
                          })
                        }
                        placeholder="Seleziona nazione"
                        isSearchable
                        styles={customSelectStyles}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary: "#cecdcd",
                            primary25: "#f5f5f5",
                            primary50: "#cecdcd"
                          }
                        })}
                      />
                    </div>
                    <div className="form-group">
                      <label>Città / Località</label>
                      <input
                        type="text"
                        value={userData.city}
                        onChange={(e) => setUserData({ ...userData, city: e.target.value })}
                      />
                    </div>
                   <div className="form-group">
                      <label>Cambia Password</label>

                      <div className="password-wrapper">
                        <input
                          type={showPassword ? "text" : "password"}
                          value={userData.password}
                          onChange={(e) =>
                            setUserData({ ...userData, password: e.target.value })
                          }
                          className="password-input"
                        />

                        <button
                          type="button"
                          onClick={() => setShowPassword(prev => !prev)}
                          className="toggle-password-btn"
                        >
                          <img
                            src={showPassword ? lock : unlock}
                            alt="toggle password"
                            className="eye-icon"
                          />
                        </button>
                      </div>
                      {getErrorMessage('password') && (
                      <p className="error">
                        {getErrorMessage('password')}
                      </p>
                    )}
                    </div>
                    <div className="form-group">
                      <label>Conferma Password</label>

                      <div className="password-wrapper">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={userData.confirmPassword}
                          onChange={(e) =>
                            setUserData({
                              ...userData,
                              confirmPassword: e.target.value
                            })
                          }
                          className="password-input"
                        />


                        <button
                          type="button"
                          onClick={() => setShowConfirmPassword(prev => !prev)}
                          className="toggle-password-btn"
                        >
                          <img
                            src={showConfirmPassword ? lock : unlock}
                            alt="toggle confirm password"
                            className="eye-icon"
                          />
                        </button>
                      </div>
                      {getErrorMessage('confirmPassword') && (
                        <p className="error">
                          {getErrorMessage('confirmPassword')}
                        </p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Codice Fiscale</label>
                      <input
                        type="text"
                        value={userData.tax_id}
                        onChange={(e) => setUserData({ ...userData, tax_id: e.target.value })}
                        maxLength={16}
                      />
                      {getErrorMessage('tax_id') && (
                      <p className="error">
                        {getErrorMessage('tax_id')}
                      </p>
                    )}
                    </div>
                    <div className="buttons">
                      <button onClick={handleUpdate} disabled={loading} className="btn-update"> <img src={Save} alt="" style={{ width: 24, marginRight: 10, marginTop: "-5px" }}/>Aggiorna</button>
                    </div>
                    <p>Per eliminare il tuo account, contatta l’assistenza a <strong>info@actainfo.it</strong></p>
                  </div>
              </div>
            )}

            
            {!userData.is_org_admin && selected === "I miei corsi" && (
              <div>
                <h2 style={{marginBottom:'20px'}}><img src={Courses} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>I miei corsi</h2>
                {courses.map(c => (
                  <div
                    key={c.id}
                    className="course-item"
                    onClick={() => goToCourse(c.slug)}
                    style={{ display: "flex", alignItems: "center", cursor: "pointer", marginBottom: "10px" }}
                  >
                    <div className="course-item-left">
                    <img src={c.main_img} alt={c.title} style={{ width: 60, height: 60, marginRight: 10, objectFit: "cover" , borderRadius: "36px" }} />
                    <div style={{display: 'flex', flexDirection:'column'}}>
                      <span title={`${c.title}`}>{c.title}</span>
                      {c.expires_at ? (
                        <span>
                        Accesso disponibile fino al:{" "}
                        <strong>
                          {new Date(c.expires_at).toLocaleDateString("it-IT")}
                        </strong>
                      </span>
                      ) : (
                        <span>
                        Accesso illimitato
                        </span>
                      )}
                    </div>
                    </div>
                    <span><img src={Trophy} alt="" className="profile-progress" />{c.total_progress} %</span>
                  </div>
                ))}
              </div>
            )}

            {!userData.is_org_admin && selected === "I miei certificati" && (
              <div>
                <h2 style={{marginBottom:'20px'}}><img src={Certificate} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>I miei certificati</h2>

                {certificates.length === 0 && (
                  <p>Nessun certificato disponibile</p>
                )}

                {certificates.map(cert => (
                  <div
                    key={cert.id}
                    className="course-item"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                      cursor: "pointer",
                      padding: "20px"
                    }}
                    onClick={() => window.open(cert.file, "_blank")}
                  >
                    <div className="course-item-left">
                      <img
                        src={Certificate}
                        alt=""
                        style={{ width: 30, height: 30, marginRight: 10 }}
                      />
                      <span title={`Visualizza certificato del corso ${cert.title}`}>Visualizza certificato del corso {cert.title}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {!userData.is_org_admin && selected === "Aggiungi coupon" && (
              <div>
                <h2 style={{marginBottom:'20px'}}><img src={Coupon} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>Aggiungi coupon</h2>

                <input
                  type="text"
                  placeholder="Inserisci codice coupon"
                  value={orgCode}
                  onChange={(e) => setOrgCode(e.target.value)}
                  style={{
                    padding: "10px",
                    width: "300px",
                    marginBottom: "10px"
                  }}
                />

                <br />

                <button
                  onClick={handleJoinOrganization}
                  disabled={joinLoading}
                  className="btn-update"
                >
                  {joinLoading ? "Convalida..." : "Conferma"}
                </button>
              </div>
            )}

            {!userData.is_org_admin && selected === "Impostazioni account" && (
                <div>
                <h2 style={{marginBottom:'20px'}}><img src={Account} alt="" style={{ width: 48, marginRight: 20, marginTop: "-5px" }}/>Impostazioni account</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label>Nome</label>
                      <input
                        type="text"
                        value={userData.first_name}
                        onChange={(e) => setUserData({ ...userData, first_name: e.target.value })}
                      />
                    {getErrorMessage('first_name') && (
                        <p className="error">{getErrorMessage('first_name')}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Cognome</label>
                      <input
                        type="text"
                        value={userData.last_name}
                        onChange={(e) => setUserData({ ...userData, last_name: e.target.value })}
                      />
                    {getErrorMessage('last_name') && (
                        <p className="error">{getErrorMessage('last_name')}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Username</label>
                      <input
                        type="text"
                        value={userData.username}
                        onChange={(e) => setUserData({ ...userData, username: e.target.value })}
                      />
                       {getErrorMessage('username') && (
                      <p className="error">{getErrorMessage('username')}</p>
                    )}
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        value={userData.email}
                        onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                      />
                      {getErrorMessage('email') && (
                      <p className="error">{getErrorMessage('email')}</p>
                    )}
                    </div>
                    <div className="form-group">
                      <label>Nazione</label>
                      <Select
                        options={countries}
                        value={
                          countries.find(
                            c => c.value === userData.nation
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setUserData({
                            ...userData,
                            nation: selectedOption?.value || ""
                          })
                        }
                        placeholder="Seleziona nazione"
                        isSearchable
                        styles={customSelectStyles}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary: "#cecdcd",
                            primary25: "#f5f5f5",
                            primary50: "#cecdcd"
                          }
                        })}
                      />
                    </div>
                    <div className="form-group">
                      <label>Città / Località</label>
                      <input
                        type="text"
                        value={userData.city}
                        onChange={(e) => setUserData({ ...userData, city: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>Cambia Password</label>

                      <div className="password-wrapper">
                        <input
                          type={showPassword ? "text" : "password"}
                          value={userData.password}
                          onChange={(e) =>
                            setUserData({ ...userData, password: e.target.value })
                          }
                          className="password-input"
                        />

                        <button
                          type="button"
                          onClick={() => setShowPassword(prev => !prev)}
                          className="toggle-password-btn"
                        >
                          <img
                            src={showPassword ? lock : unlock}
                            alt="toggle password"
                            className="eye-icon"
                          />
                        </button>
                      </div>
                      {getErrorMessage('password') && (
                        <p className="error">
                          {getErrorMessage('password')}
                        </p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Conferma Password</label>

                      <div className="password-wrapper">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={userData.confirmPassword}
                          onChange={(e) =>
                            setUserData({
                              ...userData,
                              confirmPassword: e.target.value
                            })
                          }
                          className="password-input"
                        />


                        <button
                          type="button"
                          onClick={() => setShowConfirmPassword(prev => !prev)}
                          className="toggle-password-btn"
                        >
                          <img
                            src={showConfirmPassword ? lock : unlock}
                            alt="toggle confirm password"
                            className="eye-icon"
                          />
                        </button>
                      </div>
                      {getErrorMessage('confirmPassword') && (
                        <p className="error">
                          {getErrorMessage('confirmPassword')}
                        </p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Codice Fiscale</label>
                      <input
                        type="text"
                        value={userData.tax_id}
                        onChange={(e) => setUserData({ ...userData, tax_id: e.target.value })}
                        maxLength={16}
                      />
                      {getErrorMessage('tax_id') && (
                      <p className="error">{getErrorMessage('tax_id')}</p>
                    )}
                    </div>
                    <div className="buttons">
                      <button onClick={handleUpdate} disabled={loading} className="btn-update"><img src={Save} alt="" style={{ width: 24, marginRight: 10, marginTop: "-5px" }}/>Aggiorna</button>
                    </div>
                    <p>Per eliminare il tuo account, contatta l’assistenza a <strong>info@actainfo.it</strong></p>
                  </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}